import React, { Fragment } from 'react';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import AutopayNotice from 'components/Core/Autopay-schedule/Notice/AutopayNotice';
import ScheduledInvoiceAction from 'components/Core/Autopay-schedule/ScheduledInvoiceAction/ScheduledInvoiceAction';
import FormattedDateNoTimeZone from 'components/Shared/FormattedDateNoTimeZone/FormattedDateNoTimeZone';
import Separator from 'components/Shared/Separator/Separator';

interface RegularScheduledContentProps {
  balance: number;
  currency: string;
  companyName: string;
  formattedScheduledDate: Date;
  isAutoPay: boolean;
  isSubscription: boolean;
  autoPayInterval?: string;
  shouldShowCTA: boolean;
  isSignedInUserTheScheduler: boolean;
  isUserSignedIn: boolean;
  signInCallback: () => void;
  openModal: () => void;
  cancellationInfo?: React.ReactNode;
}

const RegularScheduledContent: React.FC<RegularScheduledContentProps> = ({
  balance,
  currency,
  companyName,
  formattedScheduledDate,
  isAutoPay,
  isSubscription,
  autoPayInterval,
  shouldShowCTA,
  isSignedInUserTheScheduler,
  isUserSignedIn,
  signInCallback,
  openModal,
  cancellationInfo,
}) => {
  return (
    <Fragment>
      <div className="invoice-amount">
        <FormattedNumber value={balance} style="currency" currency={currency} />
      </div>
      <Separator height={24} />
      <div className="company-name">{companyName}</div>
      <Separator height={4} />
      <div className="scheduled-date">
        <span className="scheduled-for">
          <FormattedMessage id="SCHEDULED_FOR" defaultMessage="Scheduled for " />
        </span>
        <span>
          <FormattedDateNoTimeZone value={formattedScheduledDate} />
        </span>
      </div>
      {isAutoPay && !isSubscription ? (
        <AutopayNotice autoPayInterval={autoPayInterval || ''} />
      ) : (
        <Separator height={40} />
      )}
      {shouldShowCTA && (
        <ScheduledInvoiceAction
          cancelCallback={() => openModal()}
          isAutoPay={isAutoPay}
          isSubscription={isSubscription}
          isSignedInUserTheScheduler={isSignedInUserTheScheduler}
          isUserSignedIn={isUserSignedIn}
          signInCallback={signInCallback}
        />
      )}
      <Separator height={24} />
      {!isAutoPay && cancellationInfo}
    </Fragment>
  );
};

export default RegularScheduledContent;
